import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { masterServices } from 'src/app/module/master/services/ems-services.service';
import { ordersService } from '../../services/orders.service';
import { MessageService } from 'primeng/api';
import { error } from 'jquery';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-swap-component',
  templateUrl: './swap-component.component.html',
  styleUrls: ['./swap-component.component.css'],
})
export class swapComponentComponent {
  truckDetails: any;
  tyreList: any;
  batteryList: any;
  componantList: any;
  serialNumber: any;
  selectedComponent: any;
  componentType: any;
  associationDate: any;
  associationStatus: any;
  associationkm: any;
  associationType: any;
  maxDate: Date = new Date();
  vehicleModalPopup: boolean = false;
  selectedopt: boolean = false;
  selectedVehicle: any;

  ListData: any;
  vehicleModalPopupB: boolean = false;
  selectedVehicleB: any;
  minDate: Date = new Date();
  tyreData: any;
  batteryData: any;

  swapDate:any
  reason:any
  sourceComponentId:any
  sourceKms:any
  sourceStatus:any
  targetComponentId:any
  targetKms:any
  targetStatus:any
  remark:any
  tyreDataB: any;
  batteryDataB: any;
  selectedType: string = 'Horse';
  selectedTypeB: string = 'HorseB';
 ingredient!: string;
  statusList = [
  { value: 'Retired', label: 'Retired' },
  { value: 'Damaged', label: 'Damaged' },
  { value: 'InRepair', label: 'InRepair' },
  { value: 'Lost', label: 'Lost' },
   { value: 'Running', label: 'Running' }
]
 statusListReason = [
  { value: 'Retired', label: 'Retired' },
  { value: 'Damaged', label: 'Damaged' },
  { value: 'InRepair', label: 'InRepair' },
  { value: 'Lost', label: 'Lost' },
  { value: 'Running', label: 'Running' }
]
  ListDataB: any;
searchText: string = '';
searchTextB: string = '';
searchTimeout: any;
searchTimeoutB: any;
  constructor(
    public dialogRef: DynamicDialogRef,
    private datePipe: DatePipe,
    public data: DynamicDialogConfig,
    private masterServices: masterServices,
    private ordersService: ordersService,
    private messageService: MessageService,
    public sharedService: SharedService
  ) {
    console.log('data', data);
    this.truckDetails = data?.data?.data;
    console.log(this.truckDetails);
      if (this.selectedTypeB === 'HorseB') {
        this.callHorseAPIB();
      } else {
        this.callTrailerAPIB();
      }
   
      if (this.selectedType === 'Horse') {
        this.callHorseAPI(); 
      } else {
        this.callTrailerAPI();
      }
  }

  getList() {
    const postData = [
      // {
      //   key: 'COMPONENT_TYPE_IN',
      //   value: this.componentType,
      // },
      // {
      //   key: 'STATUS_IN',
      //   value: 'new,idle',
      // }
    ];
    this.ordersService.getTruckBuild([], 0, 1000, 'id', 'DESC').subscribe(
      (data: any) => {
        this.ListData = data?.responseObject?.content;
      },
      (err) => {
        this.componantList = [];
        this.batteryList = [];
        this.ListData = [];
      },
    );
  }

  getTrailerList() {
    const postData = [
      // {
      //   key: 'COMPONENT_TYPE_IN',
      //   value: this.componentType,
      // },
      // {
      //   key: 'STATUS_IN',
      //   value: 'new,idle',
      // }
    ];
    this.masterServices.getTrailerInfo([], 0, 1000, 'id', 'DESC').subscribe(
      (data: any) => {
        this.ListData = data?.responseObject?.content;
      },
      (err) => {
        this.componantList = [];
        this.batteryList = [];
        this.ListData = [];
      },
    );
  }

  onserialChange(event: any) {
    console.log(event);
    const componant = this.componantList.find((s: any) => s.id === event);
    console.log(componant, 'componantcomponant');
    this.selectedComponent = componant;
  }
  onChangecomponentType(associationType: any) {
    console.log(associationType);
    this.associationType = associationType;
  }

  close() {
    this.dialogRef.close('data');
  }

  onDateSelect(selectedDate: Date) {
    if (!selectedDate) return;
    const now = new Date();
    selectedDate.setHours(
      now.getHours(),
      now.getMinutes(),
      now.getSeconds(),
      now.getMilliseconds(),
    );
    this.swapDate = new Date(selectedDate);
  }

  closeVehicleModal() {
    this.vehicleModalPopup = !this.vehicleModalPopup;
  }
  openVehicleModal(key: any) {
    console.log(this.componentType,'llllllllllllllll')
    if (key == 'B') {
      this.vehicleModalPopupB = !this.vehicleModalPopupB;
    if(this.componentType){
      this.onTypeChange(this.componentType)
    }
    }
    if (key == 'A') {
      this.vehicleModalPopup = !this.vehicleModalPopup;
      if(this.componentType){
        this.onTypeChange(this.componentType)
      }
    }
    // this.getList();
  }
  selectVehicle(item: any) {
    console.log(this.selectedVehicleB , this.componentType , '===========');

    this.selectedVehicle = item;
    this.selectedopt = !this.selectedopt;
    this.vehicleModalPopup = !this.vehicleModalPopup;
    if(this.componentType){
      this.onTypeChange(this.componentType)
    }
  }

  selectVehicleB(item: any) {
    this.selectedVehicleB = item;
    this.vehicleModalPopupB = !this.vehicleModalPopupB;
    console.log(this.selectedVehicleB , this.componentType , '===========');
    if(this.componentType){
      this.onTypeChange(this.componentType)
    }
  }
  closeVehicleModalB() {
    this.vehicleModalPopupB = !this.vehicleModalPopupB;
  }

onTypeChange(event:any){
  console.log(event)
  this.componentType = event
  console.log(this.selectedType)
  console.log(this.selectedTypeB)
  if(event == 'Tyre'){
    if(this.selectedType == 'Horse'){
      console.log('1')
      this.selectedHorseComponent()
    }else if (this.selectedType == 'Trailer'){
      console.log('2')
      this.selectedTrailerComponent()
    }
    if(this.selectedTypeB == 'HorseB'){
      console.log('3')
      this.selectedHorseBComponent()
    }else if(this.selectedTypeB == 'TrailerB'){
      console.log('4')
      this.selectedTrailerBComponent()
    }
  
  }else if(event== 'Battery'){
    const postData = [
        {
          "key": "COMPONENT_TYPE_IN",
          "value": "Battery"
        },
        //  {
        //   "key":"VEHICLE_TYPE_IN",
        //   "value": "Truck"
        // },
        {
            "key": "TRUCK_BUILD_ID_IN",
            "value": this.selectedVehicle?.id
        },
      ]
    this.masterServices.getComponentInfo(postData, 0, 1000, 'id', 'DESC').subscribe(
      (data: any) => {
        this.ListData = data?.responseObject?.content;
        this.batteryData = data?.responseObject?.content;
      },
      (err) => {
        this.ListData = [];
        this.batteryData = [];
      },
    );
    const postDataB = [
      {
            "key": "TRUCK_BUILD_ID_IN",
            "value": this.selectedVehicleB?.id
        },
        {
          "key": "COMPONENT_TYPE_IN",
          "value": "Battery"
        },
    ]
    this.masterServices.getComponentInfo(postDataB, 0, 1000, 'id', 'DESC').subscribe(
      (data: any) => {
        this.batteryDataB = data?.responseObject?.content;
      },
      (err) => {
        this.batteryDataB = [];
      },
    );
    
  }
}
selectedHorseComponent(){
  console.log("0000000000000")
  const postData = [
        {
          "key": "COMPONENT_TYPE_IN",
          "value": "Tyre"
        },
        {
          "key":"VEHICLE_TYPE_IN",
          "value": "Truck"
        },
        {
            "key": "TRUCK_BUILD_ID_IN",
            "value": this.selectedVehicle?.id
        },
      ]
    this.masterServices.getComponentInfo(postData, 0, 1000, 'id', 'DESC').subscribe((data: any) => {
        this.tyreData = data?.responseObject?.content;
    },error=>{
    this.tyreData = []
  })
}
selectedTrailerComponent(){
  const postData = [
        {
          "key": "COMPONENT_TYPE_IN",
          "value": "Tyre"
        },
        {
          "key":"VEHICLE_TYPE_IN",
          "value": "Trailer"
        },
        {
            "key": "TRAILER_ID_IN",
            "value": this.selectedVehicle?.id
        },
      ]
    this.masterServices.getComponentInfo(postData, 0, 1000, 'id', 'DESC').subscribe((data: any) => {
        this.tyreData = data?.responseObject?.content;
    },error=>{
    this.tyreData = []
  })
}
selectedHorseBComponent(){
  console.log("cccccccccccc")

  const postData = [
        {
          "key": "COMPONENT_TYPE_IN",
          "value": "Tyre"
        },
        {
          "key":"VEHICLE_TYPE_IN",
          "value": "Truck"
        },
        {
            "key": "TRUCK_BUILD_ID_IN",
            "value": this.selectedVehicleB?.id
        },
      ]
    this.masterServices.getComponentInfo(postData, 0, 1000, 'id', 'DESC').subscribe((data: any) => {
        this.tyreDataB = data?.responseObject?.content;
    },error=>{
    this.tyreDataB = []
  })
}
selectedTrailerBComponent(){
  const postData = [
        {
          "key": "COMPONENT_TYPE_IN",
          "value": "Tyre"
        },
        {
          "key":"VEHICLE_TYPE_IN",
          "value": "Trailer"
        },
        {
            "key": "TRAILER_ID_IN",
            "value": this.selectedVehicleB?.id
        },
      ]
    this.masterServices.getComponentInfo(postData, 0, 1000, 'id', 'DESC').subscribe((data: any) => {
        this.tyreDataB = data?.responseObject?.content;
    },error=>{
    this.tyreDataB = []
  })
}

onVehicleChangeB() {
  if (this.selectedTypeB === 'HorseB') {
    this.callHorseAPIB(); // optional
  } else {
    this.callTrailerAPIB();
  }
  this.searchTextB = ''; // reset search if needed
  this.fetchVehiclesB()
}

onVehicleChange() {
  if (this.selectedType === 'Horse') {
    this.callHorseAPI(); // optional
  } else {
    this.callTrailerAPI();
  }
}

callTrailerAPI() {
  console.log('Trailer API called');
  this.getTrailerList()
}

callHorseAPI() {
  this.getList()
}
callHorseAPIB() {
  this.getListB()
}

callTrailerAPIB(){
  this.getTrailerListB()
}
getTrailerListB() {
    const postData = [
      // {
      //   key: 'COMPONENT_TYPE_IN',
      //   value: this.componentType,
      // },
      // {
      //   key: 'STATUS_IN',
      //   value: 'new,idle',
      // }
    ];
    this.masterServices.getTrailerInfo([], 0, 1000, 'id', 'DESC').subscribe(
      (data: any) => {
        this.ListDataB = data?.responseObject?.content;
      },
      (err) => {
        this.ListDataB = [];
      },
    );
  }

getListB() {
    const postData = [
      // {
      //   key: 'COMPONENT_TYPE_IN',
      //   value: this.componentType,
      // },
      // {
      //   key: 'STATUS_IN',
      //   value: 'new,idle',
      // }
    ];
    this.ordersService.getTruckBuild([], 0, 1000, 'id', 'DESC').subscribe(
      (data: any) => {
        this.ListDataB = data?.responseObject?.content;
      },
      (err) => {
        this.ListDataB = [];
      },
    );
  }

onSearchChangeB(value: string) {
  clearTimeout(this.searchTimeoutB);

  this.searchTimeoutB = setTimeout(() => {
    this.fetchVehiclesB();
  }, 400); // debounce
}
fetchVehiclesB() {
  const type = this.selectedTypeB === 'HorseB' ? 'HORSE' : 'TRAILER';
  const payload = 
  [{
    key: 'TRUCK_NUMBER_IN',
    value: this.searchTextB || ''
  }];
  if(type == 'HORSE'){ 
  this.ordersService.getTruckBuild(payload, 0, 500, 'id', 'DESC').subscribe((res: any) => {
    this.ListDataB = res?.responseObject?.content || [];
  },error=>{
    this.ListDataB = []
  });
}else if(type == 'TRAILER'){ 
  this.masterServices.getTrailerInfo(payload, 0, 1000, 'id', 'DESC').subscribe((res: any) => {
    this.ListDataB = res?.responseObject?.content || [];
  },error=>{
    this.ListDataB = []
  });
}
}


onSearchChange(value: string) {
  clearTimeout(this.searchTimeout);
  this.searchTimeout = setTimeout(() => {
    this.fetchVehicles();
  }, 400); // debounce
}
fetchVehicles() {
  const type = this.selectedType === 'Horse' ? 'HORSE' : 'TRAILER';
  const payload = 
  [{
    key: 'TRUCK_NUMBER_IN',
    value: this.searchText || ''
  }];
  if(type == 'HORSE'){ 
  this.ordersService.getTruckBuild(payload, 0, 500, 'id', 'DESC').subscribe((res: any) => {
    this.ListData = res?.responseObject?.content || [];
  },error=>{
    this.ListData = []
  });
}else if(type == 'TRAILER'){ 
  this.masterServices.getTrailerInfo(payload, 0, 1000, 'id', 'DESC').subscribe((res: any) => {
    this.ListData = res?.responseObject?.content || [];
  },error=>{
    this.ListData = []
  });
}
}

  confirmSwap() {

    const payload = {
      "swapDate": this.swapDate  ? this.datePipe.transform(this.swapDate , 'dd-MM-yyyy HH:mm:ss Z')  : null,
      "sourceType": this.selectedType =='Horse' ? 'TRUCK':'TRAILER',
      "sourceId": this.selectedVehicle?.id,
      "sourceComponentId": this.sourceComponentId,
      "sourceStatus": this.sourceStatus ? this.sourceStatus : 'InUse',
      "sourceKms":this.sourceKms,

      "targetType": this.selectedTypeB =='HorseB' ? 'TRUCK':'TRAILER',
      "targetId": this.selectedVehicleB?.id,
      "targetComponentId": this.targetComponentId,
      "targetStatus": this.targetStatus ? this.targetStatus : 'InUse',
      "targetKms":this.targetKms
    };
    console.log(payload);
    this.ordersService.componentSwap(payload).subscribe((data: any) => {
      if (data) {
        console.log(data);
        this.dialogRef.close(data);
        // this._route.navigate(['/orders']);
      }
    });
  }
}
